import { useQuery } from '@tanstack/react-query'
import { useParams } from '@tanstack/react-router'
import { useAtomValue } from 'jotai'

import { getInHouseQueryOptions } from '@/features/partners/query-options'
import { selectedDcIdAtom } from '@/routes/_protected/$tenantKey/-states'

/**
 * 選択中拠点の自社パートナー情報から useSiteMiddleName を取得するフック
 * @returns useSiteMiddleName の値（取得失敗時は false）
 */
export const useSiteMiddleName = () => {
  const { tenantKey } = useParams({ strict: false })
  const selectedDcId = useAtomValue(selectedDcIdAtom)

  const { data } = useQuery({
    ...getInHouseQueryOptions({
      tenantKey: tenantKey!,
      dcId: selectedDcId!
    }),
    enabled: !!tenantKey && !!selectedDcId
  })

  return data?.useSiteMiddleName ?? false
}
